import _toConsumableArray from "@babel/runtime/helpers/toConsumableArray";
var FocusService = function FocusService() {};
FocusService.focusableSelectors = ['a[href]', 'area[href]', 'input:not([disabled])', 'select:not([disabled])', 'textarea:not([disabled])', 'button:not([disabled])', 'iframe', 'object', '*[tabindex]:not([tabindex="-1"])', '*[contenteditable]'];
FocusService.focusElement = function (element) {
  if (element) {
    window.setTimeout(function () {
      element.focus();
    }, 0);
  }
};
FocusService.focusFirstElementIn = function (element) {
  var i = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 0;
  if (!element) {
    return;
  }
  var focusableElements = FocusService.getFocusableElementsIn(element);
  var firstFocusableElement = focusableElements[i];
  if (firstFocusableElement) {
    FocusService.focusElement(firstFocusableElement);
  }
};
FocusService.focusLastElementIn = function (element) {
  var offset = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 0;
  if (!element) {
    return;
  }
  var focusableElements = FocusService.getFocusableElementsIn(element);
  var lastFocusableElement = focusableElements[focusableElements.length - 1 - offset];
  if (lastFocusableElement) {
    FocusService.focusElement(lastFocusableElement);
  }
};
FocusService.getFocusableElementsIn = function (element) {
  if (!element) {
    return [];
  }
  return _toConsumableArray(element.querySelectorAll(FocusService.focusableSelectors.join(',')));
};
export default FocusService;